import { BaseHub, tpOnError } from "./BaseHub";
import { IDeviceMessageHubAction, MessageItem } from "./IActions/IDeviceMessageHubAction";

export class DeviceMessageHub extends BaseHub<IDeviceMessageHubAction> {
    constructor(onError: tpOnError) {
        super(onError, "Hubs/DeviceMessage");
    }
    public readonly getData = () => this.hub.invoke<{ [K: number]: MessageItem[] }>("GetData");
}
